(function() {

  // SHOP THE LOOK
  class ShowVariants extends HTMLElement {
    constructor() {
      super();
      this.container = this;
          this.selector = this.container.querySelectorAll(".cc__variantselector");
          this.sectionID = this.dataset.target;
          
          this.isClose = document.getElementById('CollectionsList--'+this.sectionID);
  
          if(this.isClose){
              this.ismodelclose = this.isClose.dataset.closemodal;
          }
          
  
          if (this.selector.length > 0){
              this.selector.forEach((item) => {
                  item.addEventListener("click", this.variantShow.bind(this));
              });
          }
  
  
          if(this.ismodelclose != 'false' ){
              document.addEventListener('theme:cart:change', et=>{
                  if( document.querySelector('.cc__shopthelook-open-popup')){
                   document.querySelector('.cc__shopthelook-open-popup').classList.remove('cc__shopthelook-open-popup')
                  }
               })
          }
  
    }
  
      variantShow(et){
          et.currentTarget.classList.toggle('cc_vactive');
          this.querySelectorAll("ul li").forEach(item=>{
              item.addEventListener("click", this.selectorList.bind(this));
          })
      }
  
      selectorList(et){
          const currentSelected = this.querySelector(".current_selected");
          currentSelected.innerText = et.currentTarget.innerText;
          currentSelected.dataset.value = et.currentTarget.dataset.value;
          let isAvailable = et.currentTarget.dataset.available;
  
          this.parentElement.querySelector('[name="id"]').value = et.currentTarget.dataset.value;
  
          if( this.parentElement.parentElement.parentElement.querySelector(".product-upsell__price span") ){
              this.parentElement.parentElement.parentElement.querySelector(".product-upsell__price span").innerText = et.currentTarget.dataset.price;
          }
  
          if(isAvailable){
              this.querySelector("[data-add-to-cart]").removeAttribute("disabled");
              this.querySelector("[data-add-to-cart]").innerText = theme.strings.addToCart;
          } else {
               this.querySelector("[data-add-to-cart]").setAttribute("disabled");
               this.querySelector("[data-add-to-cart]").innerText = theme.strings.soldOut;
          }
  
      }
  }
  
  if (!customElements.get("show-variants")) {
    customElements.define("show-variants", ShowVariants);
  }
  
  
  let shopthelookitems = document.querySelectorAll('.cc__shopthelook-item-content');
  let shopthelookoverlay = document.querySelectorAll('.cc__shopthelook-popup-overlay');
  
  let closebutton = document.querySelectorAll('.close-btn');
  
  if( shopthelookitems.length > 0){
      shopthelookitems.forEach(stl=>{
          stl.addEventListener('click', et=>{
              let targetpopup = et.currentTarget.dataset.target;
  
              document.getElementById(targetpopup).classList.add('cc__shopthelook-open-popup');
          });
      });
  }
  
  
  if (shopthelookoverlay.length > 0) {
    shopthelookoverlay.forEach((stl) => {
      stl.addEventListener("click", (et) => {
        et.currentTarget.parentElement.classList.remove("cc__shopthelook-open-popup");
      });
    });
  }
  
  if( closebutton.length > 0 ){
      closebutton.forEach(btn=>{
          btn.addEventListener('click', etbtn=>{
              let targetpopup = etbtn.currentTarget.dataset.target;
              document.getElementById(targetpopup).classList.remove('cc__shopthelook-open-popup');
          })
      })
  }
  // END SHOP THE LOOK

  // CUSTOM TAB COLLECTIONS
  document.querySelectorAll('.tab-link').forEach((item)=>{
      item.addEventListener('click', et=>{
          let sectionidd = et.currentTarget.dataset.section;
          let dataurl = et.currentTarget.dataset.url;

          if( sectionidd && dataurl ){
              document.getElementById(sectionidd).querySelector('.btnholder a').href = dataurl;
          }
      })
  });
  // END CUSTOM TAB COLLECTIONS


class GiftWrapProduct extends HTMLElement {
    static lastChecked = null;
  
    constructor() {
      super();
  
      // Create the label element and set it as clickable
      this.label = document.createElement('label');
      this.label.style.cursor = 'pointer';
  
      // Create the checkbox input
      this.checkbox = document.createElement('input');
      this.checkbox.type = 'checkbox';
      this.checkbox.id = 'gift-wrap-checkbox';
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
  
      // Append the checkbox to the label so that the whole label is clickable
      this.label.appendChild(this.checkbox);
  
      // Add label text
      const labelText = document.createElement('span');
      labelText.textContent = this.getAttribute('label') || 'Add Gift Wrap';
      this.label.appendChild(labelText);
  
      // Append the label to the custom element
      this.appendChild(this.label);
  
      this.sectionid = this.closest('.product-form').dataset.sectionid;
      this.mainatc = document.querySelector(`#AddToCart--${this.sectionid}`);

      this.formId = this.closest('.product-form').dataset.formid;

      this.formm = document.getElementById(`ProductForm--${this.formId}`);

      
    }
  
    connectedCallback() {
      // Find the "Add to Cart" button in the closest product form
      const productForm = this.closest('.product-form');
      if (productForm) {
        this.addToCartButton = productForm.querySelector('[type="submit"]');
        
        if (this.addToCartButton) {
          // Disable the button initially if no checkbox is checked
          this.updateButtonState();
  
          // Add an event listener for the button click
          this.addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this));
        }
      }
    }
  
    handleCheckboxChange() {
      const variantId = this.getAttribute('gift-variant-id'); // Gift wrap product variant ID
      const closestInput = this.closest('.product-form').querySelector('input[name="id"]');      
      this.atc = document.querySelector(`#AddToCart--giftwrap${this.sectionid}`);
      
  
      if (this.checkbox.checked) {
        // Uncheck the previously checked checkbox, if any
        if (GiftWrapProduct.lastChecked && GiftWrapProduct.lastChecked !== this) {
          GiftWrapProduct.lastChecked.checkbox.checked = false;
        }
  
        // Update the closest input[name="id"] with the gift wrap variant ID
        if (closestInput) {
          closestInput.value = variantId;
        }        

        this.formm.insertAdjacentHTML('beforeend', `<input class="pg_prop" type="hidden" name="properties[Want it gift wrapped?]" value="Yes please" />`);
  
        // Update the last checked reference to this checkbox
        GiftWrapProduct.lastChecked = this;

        document.addEventListener('theme:product:added', et=>{
          this.atc.click();
        });
      } else {
        this.formm.querySelector(`.pg_prop`).remove();

        // Clear the input[name="id"] if the checkbox is unchecked
        if (closestInput) {
          closestInput.value = '';
        }
        GiftWrapProduct.lastChecked = null;
      }
  
      // Update button state based on checkbox state
      this.updateButtonState();
    }
  
    handleAddToCartClick(event) {
      const productForm = this.closest('.product-form');
      const variantId = this.getAttribute('gift-variant-id');
      const closestInput = productForm.querySelector('input[name="id"]');
  
      // If the checkbox is checked, set the variant ID
      if (this.checkbox.checked && closestInput) {
        closestInput.value = variantId;
      }
    }
  
    updateButtonState() {
      if (this.addToCartButton) {
        // Disable the button if no checkbox is checked, enable it if one is checked
        this.addToCartButton.disabled = !this.checkbox.checked;
      }
    }
  }
  
  // Define the custom element
  customElements.define('gift-wrap-product', GiftWrapProduct);
})();